module.exports = __webpack_public_path__ + "pc/img/pc_logo.915b153d.svg";